import type { Layout } from "../tokens.ts";

/** Derived from the BLS service agreement: no cover, large logo and reference on every page, a title block. */
export const contractLayout: Layout = {
  key: "contract",
  name: "Contract",
  titleBlock:
    '<p class="kl-tb"><span class="kl-tb-main">{{docType}}</span> <span class="kl-tb-accent">{{subtitle}}</span></p>',
  header:
    '<table class="kl-hf kl-hf-header"><tr><td class="kl-hf-left"><img class="kl-header-logo" src="{{logo.header}}" alt=""></td><td class="kl-hf-right kl-reference">{{code}}</td></tr></table>',
  footer:
    '<table class="kl-hf kl-hf-footer"><tr><td class="kl-hf-left"></td><td class="kl-hf-right"><span class="kl-page-number"></span></td></tr></table>',
  css: `@page { margin: 118pt 40pt 54pt 40pt; @top-center { padding-top: 18pt; } }
.kl-hf-header { border-bottom-width: 0; }
.kl-hf-header td { vertical-align: top; }
.kl-header-logo { width: 125pt; height: 88.4pt; }
.kl-reference { font-size: 8pt; font-weight: bold; font-style: italic; color: var(--kl-accent); }
.kl-hf-footer { border-top-width: 0; }
.kl-title-block { margin-bottom: 14pt; }
.kl-title-block .kl-tb { text-align: center; font-size: 16pt; font-weight: bold; color: var(--kl-text); }
.kl-tb-accent { color: var(--kl-primary); }
.kl-body .kl-h1 { font-size: var(--kl-size-body); border-bottom-width: 0; padding-bottom: 0; }
.kl-body .kl-h1[data-number]::before { content: counter(kl-h1) ".   "; }
.kl-body .kl-h2 { font-size: var(--kl-size-body); }
`,
};
